module.exports = "#ifdef USE_THEMING\noutFragColor.rgb = mix(outFragColor.rgb, themingColor.rgb, themingColor.a);\n#endif\n";